import * as React from "react"
import { Box, Stack, Text } from "@chakra-ui/react"

interface InformationOverlayProps {
  isMobile: boolean
  toggleShowLeaveOverlay: (e: React.MouseEvent<HTMLElement>) => void
  isTouchDelay: boolean
  handleTouchStart: (event: React.TouchEvent<HTMLDivElement>) => void
  toggleShowLeaveOverlayTouchEnd: (
    event: React.TouchEvent<HTMLDivElement>
  ) => void
  isSmallMainScreen: boolean
}

const _InformationOverlay: React.FC<InformationOverlayProps> = ({
  isMobile,
  toggleShowLeaveOverlay,
  isTouchDelay,
  handleTouchStart,
  toggleShowLeaveOverlayTouchEnd,
  isSmallMainScreen
}) => {
  return (
    <Box
      top="5%"
      backgroundColor="#00000054"
      padding={isMobile ? "5px 8px" : "5px 10px"}
      color="#ffffff"
      left="50%"
      borderRadius="5px"
      transform="translate(-50%)"
      zIndex="1200 !important"
      flex={1}
      alignItems="center"
      justifyContent="center"
      position="absolute"
      width={(isMobile || isSmallMainScreen) && "70%"}
      onClick={toggleShowLeaveOverlay}
      onTouchStart={!isTouchDelay ? handleTouchStart : null}
      onTouchEnd={!isTouchDelay ? toggleShowLeaveOverlayTouchEnd : null}
    >
      <Stack alignItems="center">
        <Text fontSize={"sm"} textAlign="center">
          {isMobile
            ? "Currently no presenters"
            : "There are currently no presenters"}
        </Text>
        <Text fontSize={"xs"} marginTop="0px !important" textAlign="center">
          {isMobile
            ? "Live action will start when one joins"
            : "Live action will start when a presenter joins"}
        </Text>
      </Stack>
    </Box>
  )
}

export const InformationOverlay = React.memo(_InformationOverlay)
